// components/Shop/RootCategoryPage.jsx
import React from "react";
import CategoryCard from "./CategoryCard";

export default function RootCategoryPage({ category, childrenCategories = [] }) {
  return (
    <div className="min-h-screen bg-white font-[Vazirmatn,IRANSans,sans-serif] text-gray-800">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-5 sm:py-8 lg:px-6">
        {/* Page Header */}
        <div className="mb-6 sm:mb-8">
          <h1 className="mt-3 text-lg font-bold leading-tight text-[#1E3A5F] sm:text-xl md:text-2xl">
            دسته {category?.name}
          </h1>

          <p className="mt-2 max-w-3xl text-sm leading-7 text-gray-600 sm:text-base">
            زیردسته‌های مرتبط با این دسته اصلی را مشاهده کنید.
          </p>
        </div>

        {/* Categories Grid */}
        <section className="mb-8 sm:mb-10">
          <div className="mb-4 flex items-center justify-between gap-3">
            <h2 className="text-sm font-semibold text-gray-900 sm:text-base">
              زیر دسته‌ها
            </h2>

            <span className="text-xs text-gray-500 sm:text-sm">
              {childrenCategories.length} مورد
            </span>
          </div>

          {childrenCategories.length > 0 ? (
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
              {childrenCategories.map((child) => (
                <div key={child.id} className="min-w-0">
                  <CategoryCard category={child} />
                </div>
              ))}
            </div>
          ) : (
            <div className="rounded-2xl border border-gray-200 bg-[#F9FAFB] px-4 py-10 text-center">
              <p className="text-sm text-gray-500">
                زیرمجموعه‌ای برای نمایش وجود ندارد
              </p>
            </div>
          )}
        </section>

        {/* Description Section */}
        <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-100 px-4 py-4 sm:px-5">
            <h2 className="text-base font-semibold text-gray-900">
              معرفی دسته‌ها
            </h2>
            <p className="mt-1 text-xs leading-6 text-gray-500 sm:text-sm">
              توضیحات کوتاه برای آشنایی بیشتر با هر زیرمجموعه
            </p>
          </div>

          <div className="space-y-4 px-4 py-4 sm:space-y-5 sm:px-5 sm:py-5">
            {childrenCategories.length > 0 ? (
              childrenCategories.map((child, index) => (
                <article
                  key={child.id}
                  className="rounded-xl bg-[#F9FAFB] p-4 ring-1 ring-[#E5E7EB]"
                >
                  <div className="mb-2 flex items-start gap-3">
                    <div className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-[#00AFA9]" />
                    <div className="min-w-0">
                      <h3 className="text-sm font-semibold text-[#1E3A5F] sm:text-base">
                        {index + 1}. {child.name}
                      </h3>
                    </div>
                  </div>

                  {child.description ? (
                    <p className="text-sm leading-7 text-gray-600">
                      {child.description}
                    </p>
                  ) : (
                    <p className="text-sm leading-7 text-gray-400">
                      برای این دسته توضیحی ثبت نشده است.
                    </p>
                  )}
                </article>
              ))
            ) : (
              <div className="rounded-xl bg-[#F9FAFB] p-4 text-sm text-gray-500">
                توضیحی برای نمایش وجود ندارد.
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}
